import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "DPz5y6",
    defaultMessage: "Assign Staff Members",
    description: "dialog header",
  },
  searchInputLabel: {
    id: "UQ4Kuh",
    defaultMessage: "Search Staff Members",
    description: "input label",
  },
  searchInputPlaceholder: {
    id: "6sjBvJ",
    defaultMessage: "Search by name, email, etc...",
    description: "input placeholder",
  },
  staffActive: {
    id: "9Zlogd",
    defaultMessage: "Active",
    description: "staff member status",
  },
  staffInactive: {
    id: "7WzUxn",
    defaultMessage: "Inactive",
    description: "staff member status",
  },
  noMembersFound: {
    id: "jUuHVn",
    defaultMessage: "No members found",
    description: "description",
  },
});
